import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ target, large = false }) => {
  const calc = () => {
    const diff = Math.max(0, new Date(target).getTime() - Date.now());
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor(diff / 3600000) % 24,
      m: Math.floor(diff / 60000) % 60,
      s: Math.floor(diff / 1000) % 60,
    };
  };
  const [t, setT] = useState(calc);

  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  const cells = [
    [t.d, "dgn"],
    [t.h, "uur"],
    [t.m, "min"],
    [t.s, "sec"],
  ];

  return (
    <div className="grid grid-cols-4 gap-1.5" data-testid="countdown-timer">
      {cells.map(([v, label]) => (
        <div
          key={label}
          className={`rounded-md border border-white/10 bg-black/60 text-center ${large ? "rounded-xl py-3 sm:py-4" : "py-1.5"}`}
        >
          <div
            className={`font-mono font-semibold leading-none tabular-nums ${
              large ? "text-2xl sm:text-4xl" : "text-base sm:text-lg"
            } ${label === "sec" ? "text-white" : "text-volt"}`}
          >
            {pad(v)}
          </div>
          <div
            className={`mt-1 font-mono uppercase tracking-widest text-slate-500 ${
              large ? "text-[10px]" : "text-[9px]"
            }`}
          >
            {label}
          </div>
        </div>
      ))}
    </div>
  );
};
